import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../i18n/LanguageContext";
import "../components/AppShell.css";

export const DevTextareaPage = () => {
  const { portal } = useLanguage();
  const copy = portal.testPage;
  const common = portal.common;

  useEffect(() => {
    document.title = copy.title;
  }, [copy.title]);

  return (
    <div className="app-shell">
      <main className="app-main">
        <div className="app-intro">
          <div className="app-intro-copy">
            <h1>{copy.title}</h1>
          </div>
          <div className="app-intro-action">
            <Link to="/app/snippets" className="app-primary">
              {common.goToDashboard}
            </Link>
          </div>
        </div>

        <section className="app-form-card">
          <textarea className="try-note" aria-label={copy.textareaAria} />
        </section>

        <p>{copy.lead}</p>

        <ol className="try-instructions" style={{ marginBottom: 24, maxWidth: 680 }}>
          {(copy.steps || []).map((step) => (
            <li key={step}>{step}</li>
          ))}
        </ol>
      </main>
    </div>
  );
};
